import React from 'react';

const PermissionCheck = ({ allPermission, setAllPermission, cameraAvailable, handleGoBack, styles }) => {
  if (!allPermission) {
    return (
      <div style={styles.container}>
        <div style={styles.centered}>
          <h3>Please Allow All Permissions</h3>
          <button style={styles.button} onClick={() => setAllPermission(true)}>
            Allow
          </button>
        </div>
      </div>
    );
  }

  if (!cameraAvailable) {
    return (
      <div style={styles.container}>
        <div style={styles.centered}>
          <h3>No camera available</h3>
          <p>Please connect a camera to use this feature.</p>
          <button style={styles.button} onClick={handleGoBack}>
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default PermissionCheck;
